import { jsx as _jsx } from "react/jsx-runtime";
import { Alert } from '@cancercentrum/rcc-bootstrap';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { errandButtonUtils } from '../../errandButtonUtils';
import { SimplifiedErrandButtonTags } from '../../constants';
import { hideWhenReadOnlyRule } from '../commonRules';
import { DeleteModal } from './DeleteModal';
export const DeleteButton = {
    key: 'radera',
    text: 'Radera',
    prio: 99999,
    section: 'end',
    icon: faTrashCan,
    buttonStyle: 'danger',
    ModalComponent: DeleteModal,
    onClick: async (row, inca, showModal, ctx, api)=>{
        const res = await showModal();
        if (!res.isSuccess) {
            return;
        }
        const transitionRes = await errandButtonUtils.performStateTransition('avbryt_radera', ctx, api);
        if (!transitionRes) {
            return;
        }
        api.setRootComponent(/*#__PURE__*/ _jsx(Alert, {
            bsStyle: "success",
            children: "Ärendet har tagits bort."
        }));
    },
    defaultRules: [
        hideWhenReadOnlyRule,
        {
            id: 'disableDeleteRule',
            description: 'Knappen blir disabled när användaren är inrapportör och ärendet antingen blivit delsparat eller startats av monitor.',
            evaluateState: (row, inca)=>{
                const { Paminnelse, Komplettera, Remiss } = SimplifiedErrandButtonTags;
                const isReviewerStartSituation = inca.errand?.startSituation?.name === 'Monitor inrapportör';
                const isStartedByReviewer = [
                    Paminnelse,
                    Komplettera,
                    Remiss
                ].some((tag)=>inca.errand?.errandTags?.includes(tag)) || isReviewerStartSituation;
                const isPartlySaved = inca.errand?.errandTags?.includes(SimplifiedErrandButtonTags.Delspara);
                if (!inca.user.role.isReviewer && isStartedByReviewer || isPartlySaved) {
                    return {
                        state: 'Disabled',
                        tooltip: 'Ärendet kan inte raderas. Det beror antingen på att data har sparats i registret eller att ärendet har hanterats av RCC.'
                    };
                }
                return {
                    state: 'Visible'
                };
            }
        }
    ]
};
